import fastDeepEqual from 'fast-deep-equal';
import { configureIguazu } from 'iguazu';
import debounce from 'lodash.debounce';

export function configure() {
  const delay = 100;

  configureIguazu({
    stateChangeLimiter: (onStateChange) => debounce(onStateChange, delay),
    stateChangeComparator: fastDeepEqual,
  });
}
